import React from 'react';
import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(() => ({
    chartWrapper: { width: 1024, height: 515, position: 'absolute', left: 0, top: 53 },
}));
export const ToleranceAreaChart = ({ chartData, domain }) => {
    var _a;
    const classes = useStyles();
    const tolerance = ((_a = chartData[0]) === null || _a === void 0 ? void 0 : _a.tolerance) || [0, 0];
    const data = [{ tolerance }, { tolerance }];
    return (React.createElement("div", { className: classes.chartWrapper },
        React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
            React.createElement(AreaChart, { width: 600, height: 400, data: data, margin: { top: 20, right: 30, left: 20, bottom: 5 } },
                React.createElement(XAxis, { tick: false }),
                React.createElement(YAxis, { domain: domain, tick: false }),
                React.createElement(Area, { dataKey: "tolerance", stroke: "#EEF9E8", fill: "#EEF9E8" })))));
};
//# sourceMappingURL=ToleranceAreaChart.js.map